module.exports = __webpack_public_path__ + "static/media/ic_product_st_production.382c3d6c.svg";